// extracted by mini-css-extract-plugin
export default {"root":"OfferBar_root__JOopV","text":"OfferBar_text__9bZam"};